import React, { useContext } from "react";
import PageListerHelper from "./PageListerHelper";
import StandardPageListerPanel from "./StandardPageListerPanel";
import "./PageLister.css";
import { PagesManagementContext } from "../../routes/builderContexts";
import { AbstractTooltip as Tooltip } from "../ToolTip/ToolTip";

function isUsablePageListerIdentity(identity, upperBound) {
  return Number.isInteger(identity) && identity >= 0 && identity < upperBound;
}

export function normalizePageListerContentPages(contentPages) {
  const usedIds = new Set();
  const pages = contentPages.map((page) => ({ ...page }));
  const order = new Array(pages.length);
  const pagesNeedingIdentity = [];

  pages.forEach((page, index) => {
    const pageIdentity = page.uniquePageListerID;

    if (isUsablePageListerIdentity(pageIdentity, pages.length) && !usedIds.has(pageIdentity)) {
      usedIds.add(pageIdentity);
      order[index] = pageIdentity;
      return;
    }

    pagesNeedingIdentity.push({ page, index });
  });

  let nextIdentity = 0;
  pagesNeedingIdentity.forEach(({ page, index }) => {
    while (usedIds.has(nextIdentity)) {
      nextIdentity += 1;
    }

    page.uniquePageListerID = nextIdentity;
    usedIds.add(nextIdentity);
    order[index] = nextIdentity;
  });

  return {
    pages,
    order,
  };
}

const PageLister = () => {
  const pagesManagementContext = useContext(PagesManagementContext);
  const firstPages = pagesManagementContext.lessonPages.filter((e, i) => i <= 3);
  const content = normalizePageListerContentPages(
    pagesManagementContext.lessonPages.filter((e, i, a) => i >= 4 && i <= a.length - 4),
  ).pages;
  const lastPages = pagesManagementContext.lessonPages.filter((e, i, a) => i > a.length - 4);

  function returnCorrect(juice, pageToGoTo) {
    let newPages = [...firstPages, ...juice, ...lastPages].map((el, i) => {
      el.order = i;
      return el;
    });
    pagesManagementContext.changePageOrder(newPages, pageToGoTo);
  }
  const switchPage = (i, flag) => {
    if (flag === "start") {
      pagesManagementContext.switchCurrentlyDisplayedPage(i);
    } else {
      let value = pagesManagementContext.lessonPages.length - 3 + i;
      pagesManagementContext.switchCurrentlyDisplayedPage(value);
    }
  };

  return (
    <React.Fragment>
      {pagesManagementContext.lessonPages.length > 3 ? (
        <div className="pages-container" data-tooltip-id="Page List">
          <Tooltip id="Page List" />
          <div className="standard-side-panel-container">
            <StandardPageListerPanel pagePullout={pagesManagementContext.pagePullout} flagDirection={"title"} />

            {firstPages.map((el, i) => {
              return (
                <div key={el.name + i}>
                  <StandardPageListerPanel
                    pagePullout={pagesManagementContext.pagePullout}
                    switchPage={switchPage}
                    flagDirection={"start"}
                    index={i}
                    name={el.name}
                    modes={el.lessonModeIds}
                  />
                </div>
              );
            })}
          </div>
          <PageListerHelper
            lessonModes={pagesManagementContext.lessonModes}
            pagesManagementContext={pagesManagementContext}
            lessonPages={content}
            updateArray={returnCorrect}
          />
          <div className="standard-side-panel-container">
            {lastPages.map((el, i) => {
              return (
                <div key={el.name + i}>
                  <StandardPageListerPanel
                    pagePullout={pagesManagementContext.pagePullout}
                    switchPage={switchPage}
                    flagDirection={"end"}
                    index={i}
                    name={el.name}
                    modes={el.lessonModeIds}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
    </React.Fragment>
  );
};
export default PageLister;
